import React from 'react';
import { FaPlus, FaMinus, FaTrashAlt, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';

const CartItemsList = ({ 
  cartItems, 
  quantities, 
  onDecrement, 
  onIncrement,
  onRemoveAddon,
  onRemoveItem,
  onReAddAddon,
  onUpdateAddon,
}) => {
  const [expandedItems, setExpandedItems] = React.useState({});

  const toggleExpand = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  return (
    <div style={{ padding: '4px 0' }}>
      {cartItems.map(item => {
        const qty = quantities[item.itemId] || item.quantity || 1;
        const price = parseFloat(item.effectivePrice) || parseFloat(item.price) || 0;
        const hasAddons = item.addons && item.addons.length > 0;
        const isExpanded = expandedItems[item.itemId] || false;

        return (
          <div
            key={item.itemId}
            style={{
              background: '#ffffff',
              borderRadius: '14px',
              padding: '14px 16px',
              marginBottom: '12px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              border: '1px solid #f0f0f0',
              transition: 'all 0.2s ease',
              position: 'relative'
            }}
          >
            {/* Remove Item Button */}
            {onRemoveItem && (
              <button
                onClick={() => onRemoveItem(item)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  color: '#ccc',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '4px',
                  borderRadius: '50%',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '28px',
                  height: '28px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#fff5f5';
                  e.currentTarget.style.color = '#e74c3c';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'none';
                  e.currentTarget.style.color = '#ccc';
                }}
              >
                <IoClose size={16} />
              </button>
            )}

            {/* Main Row */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              {/* Image */}
              <img
                src={item.dishImage || 'https://via.placeholder.com/60x60/FFE1CF/ee6521?text=Food'}
                alt={item.dishName}
                style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '12px',
                  objectFit: 'cover',
                  flexShrink: 0,
                  border: '2px solid #fafafa',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                }}
              />

              {/* Details */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: '8px'
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontWeight: '600',
                      fontSize: '13px',
                      color: '#1a1a1a',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      scrollbarWidth: 'none',
                      textOverflow: 'ellipsis'
                    }}>
                      {item.dishName}
                    </div>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      marginTop: '2px'
                    }}>
                      
                      
                    </div>
                  </div>
                  <div style={{
                    color: '#2e7d32',
                    fontSize: '14px',
                    fontWeight: '700',
                    flexShrink: 0
                  }}>
                    ₹{price.toFixed(2)}
                  </div>
                </div>

                {/* Bottom Row: Quantity + Total */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '8px',
                  gap: '8px'
                }}>
                  {/* Quantity Controls */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    background: '#f8f8f8',
                    borderRadius: '20px',
                    padding: '2px 4px',
                    flexShrink: 0
                  }}>
                    <button
                      onClick={() => onDecrement(item)}
                      style={{
                        width: '26px',
                        height: '26px',
                        borderRadius: '50%',
                        border: 'none',
                        background: '#ffffff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        color: '#555',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#ff6b35';
                        e.currentTarget.style.color = '#fff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.color = '#555';
                      }}
                    >
                      <FaMinus size={10} />
                    </button>

                    <span style={{
                      minWidth: '24px',
                      textAlign: 'center',
                      fontWeight: '600',
                      fontSize: '12px',
                      color: '#1a1a1a'
                    }}>
                      {qty}
                    </span>

                    <button
                      onClick={() => onIncrement(item)}
                      style={{
                        width: '26px',
                        height: '26px',
                        borderRadius: '50%',
                        border: 'none',
                        background: 'linear-gradient(135deg, #ee6521 0%, #e85d1c 100%)',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 6px rgba(238, 101, 33, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <FaPlus size={10} />
                    </button>
                  </div>

                  {/* Total Price */}
                  <div style={{
                    fontWeight: '700',
                    color: '#ee6521',
                    fontSize: '14px',
                    background: '#FFF5EE',
                    padding: '2px 12px',
                    borderRadius: '12px',
                    flexShrink: 0
                  }}>
                    ₹{(price * qty).toFixed(2)}
                  </div>

                  {/* Expand/Collapse Addons Button */}
                  {hasAddons && (
                    <button
                      onClick={() => toggleExpand(item.itemId)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#999',
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '12px',
                        transition: 'all 0.2s ease',
                        flexShrink: 0
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#ee6521';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#999';
                      }}
                    >
                      {isExpanded ? (
                        <FaChevronUp size={10} />
                      ) : (
                        <FaChevronDown size={10} />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Addons Section - Expandable */}
            {hasAddons && isExpanded && (
              <div style={{
                marginTop: '12px',
                paddingTop: '12px',
                borderTop: '1px solid #f5f5f5'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <span style={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#999',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    Selected Addons
                  </span>
                  <span style={{
                    fontSize: '9px',
                    color: '#fff',
                    background: '#ee6521',
                    padding: '1px 8px',
                    borderRadius: '10px',
                    fontWeight: '600'
                  }}>
                    {item.addons.length}
                  </span>
                </div>

                {item.addons.map((addon) => (
                  <div
                    key={addon.id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px 0',
                      borderBottom: '1px solid #f8f8f8'
                    }}
                  >
                    {/* Left Section - Addon Name */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      fontSize: '11px',
                      color: '#555',
                      flex: 1
                    }}>
                      <span style={{ fontWeight: '500' }}>{addon.addonName}</span>
                    </div>

                    {/* Center Section - Quantity Controls (Perfectly Centered) */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      background: '#f8f8f8',
                      borderRadius: '20px',
                      padding: '3px 6px',
                      minWidth: '80px'
                    }}>
                      <button
  onClick={() => {
    onUpdateAddon(
      item.itemId,
      addon.addonId || addon.id,
      Math.max(0, addon.quantity - 1)
    );
  }}
  style={{
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: 'none',
    background: '#ffffff',
    cursor: 'pointer',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    color: '#555',              // Always active
    transition: 'all 0.2s ease',
    opacity: 1,                 // Always visible
    pointerEvents: 'auto'       // Always clickable
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = '#ff6b35';
    e.currentTarget.style.color = '#fff';
    e.currentTarget.style.transform = 'scale(1.05)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = '#ffffff';
    e.currentTarget.style.color = '#555';
    e.currentTarget.style.transform = 'scale(1)';
  }}
>
  <FaMinus size={9} />
</button>

                      <span style={{
                        minWidth: '28px',
                        textAlign: 'center',
                        fontWeight: '700',
                        fontSize: '13px',
                        color: '#1a1a1a'
                      }}>
                        {addon.quantity}
                      </span>

                      <button
                        onClick={() =>
    onUpdateAddon(
      item.itemId,
      addon.addonId || addon.id,
      addon.quantity + 1
    )
  }
                        style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '50%',
                          border: 'none',
                          background: 'linear-gradient(135deg, #ee6521 0%, #e85d1c 100%)',
                          color: '#fff',
                          cursor: 'pointer',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 6px rgba(238, 101, 33, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.1)';
                          e.currentTarget.style.boxShadow = '0 3px 10px rgba(238, 101, 33, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 6px rgba(238, 101, 33, 0.3)';
                        }}
                      >
                        <FaPlus size={9} />
                      </button>
                    </div>

                    {/* Right Section - Price & Delete */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}>
                      <span style={{
                        color: '#2e7d32',
                        fontWeight: '600',
                        fontSize: '11px',
                        minWidth: '50px',
                        textAlign: 'right'
                      }}>
                        ₹{addon.totalPrice || (addon.price * addon.quantity)}
                      </span>
                      
                      {/* Remove Addon Button */}
                      {onRemoveAddon && (
                        <button
                          onClick={() => onRemoveAddon(item, addon)}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#ddd',
                            cursor: 'pointer',
                            padding: '4px',
                            borderRadius: '50%',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '24px',
                            height: '24px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#ffebee';
                            e.currentTarget.style.color = '#e74c3c';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'none';
                            e.currentTarget.style.color = '#ddd';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        >
                          <FaTrashAlt size={10} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}

                {/* Re-add Addon Button */}
                
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CartItemsList;